import { Tooltip } from '@pmi/dsm-react';
import { AlertInfoSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { TableCellProps } from '../models';
import { mapAccessTypeToLabel } from '../../../../../../shared/utils/mapAccessTypeToLabel';
import styles from './roleCell.module.scss';

function RoleCell({ row }: TableCellProps) {
  const roleLabel = mapAccessTypeToLabel(row.original.accessType);

  if (row.original.role) {
    return <span className={styles.roleContainerRegular}>{roleLabel}</span>;
  }
  const rkey = (Math.random() + 1).toString(36).substring(7);

  return (
    <span
      className={`${styles.roleContainerCustom} d-flex align-items-center`}
      key={`roleContainer-${row.original.personId}${rkey}`}
    >
      <span>Custom</span>
      <Tooltip
        type="sm"
        content={null}
        placement="top"
        className="darkTooltip"
        key={`adminRoleTooltip-${row.original.personId}${rkey}`}
      >
        <AlertInfoSolidIcon className="infoicon" fontSize="xs" />
      </Tooltip>
    </span>
  );
}

export default RoleCell;
